import React, { useState } from "react";
import { IconCheckCircle, TimerIcon, IconContract, SolarPower, VerifiedCircleIcon, ArticleIcon, SolarPowerIcon, NewTimerIcon } from "../../../../assests/icons/Icons";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import { getCurrencyLabel, projectInstallationDays, projectCostBreakdown, formatEnergyGeneration, formatMoney } from "../../../../Utils/commonFunctions";
import { setSeeProposal } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";

const metrics = [
    { label: "Annual energy generation", value: "XX,XXX kWh/yr" },
    { label: "Total project cost", value: "₹XX,XXX Lakh" },
    { label: "Upfront payment after subsidy", value: "₹XX,XXX Lakh" },
    { label: "Payback period", value: "~4.2 years" },
];

const FinalProposalCard = () => {
    const dispatch = useAppDispatch();
    const [collapsed, setCollapsed] = useState(false);
    const { roofAnalysis:{formDetails:{projectSetup},selected_project }}  = useAppSelector(state=>state.consumerReducers)
    const {user:{country_mstr}}  = useAppSelector(state=> state.auth)
    const costBreakdown = projectCostBreakdown(selected_project);

    return (
        <div className="border border-gray-200 rounded-md bg-white max-h-[440px]">
            {/* Card header — collapsible */}
            {/* <button type="button" className="w-full flex justify-between items-center px-5 py-3.5 cursor-pointer" onClick={() => setCollapsed((prev) => !prev)}  > */}
            <button type="button" className="w-full flex justify-between items-center px-5 py-3.5 cursor-default pointer-events-none" onClick={() => {}}  >
                <span className="text-[10px] font-Roboto uppercase  text-[#616161]">  Final Optimized Proposal </span>
                {/* Chevron */}
                <svg className={`w-4 h-4 text-[#616161] transition-transform duration-200 ${collapsed ? "-rotate-90" : "rotate-0"}`} fill="none" stroke="currentColor"  strokeWidth={2} viewBox="0 0 24 24" >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {!collapsed && (
                <div className="px-5 ">
                    {/* Header Section */}
                   <div className="mb-4">
                     <div className="">
                       <h3 className="heading-14-roboto">{costBreakdown.isBooked ? "Your installation is booked" : "Your solar estimate is ready"}</h3>
                       <p className="text-12-roboto mt-1">
                        {costBreakdown.isBooked
                          ? "Booking amount received. Here is your final system and the remaining amount, paid in milestones during installation."
                          : "Based on your roof size and location, see your system size, savings, and choose how you want to install."}
                       </p>
                     </div>
                   </div>

                    {/* System size */}
                     <div className="flex gap-2 mb-1">
                               <span className="pt-2"><SolarPowerIcon /> </span>
                             <div>
                               <span className="heading-12-roboto">Final Plant Size (AC)</span>
                             <p className="text-xl font-semibold text-[rgba(17,63,74,1)] mb-1">{selected_project?.plant_ac_capacity != null ? Number(selected_project.plant_ac_capacity).toFixed(2) : ""}{` kW`}</p>
                             </div>
                              {/* <button onClick={()=>dispatch(setSeeProposal(true))} className="text-[12px] font-Roboto text-[rgba(0,0,0,1)] underline decoration-gray-400 cursor-default ml-auto ">
                                  See Full Proposal
                               </button> */}
                       </div>
                           {/* Stats List */}
                         <div className="border-t border-gray-200 py-3.5 flex flex-col gap-3 mb-1"> 
                           <div className="flex justify-between items-center">
                               <span className="heading-12-inter">Annual energy generation</span> 
                               <span className="heading-14-inter-info">{!selected_project?.project_generation_details?.pvnxt_generation ? `${formatEnergyGeneration(((+selected_project?.yearlygensanctioned!)||0)?.toFixed(2))}` : `${formatEnergyGeneration(((+selected_project?.project_generation_details?.pvnxt_generation!)||0)?.toFixed(2))}`}</span> 
                           </div>
                           {/* <div className="flex justify-between items-center">
                               <span className="heading-12-inter">Total project cost</span>
                               <span className="heading-14-inter-info">{`${getCurrencyLabel(country_mstr)} ${formatMoney((((+selected_project?.projectcost!)||0)  / country_mstr?.currencyrate!),"tt")}`}</span>
                           </div> */}
                           {/* <div className="flex justify-between items-center">
                               <span className="heading-12-inter">Upfront payment after subsidy</span>
                               <span className="heading-14-inter-info">{"--"}</span>
                           </div> */}
                           <div className="flex justify-between items-center">
                           <span className="heading-12-inter">Payback period</span>
                           <span className="heading-14-inter-info">{selected_project?.savingperiod ?? 0}{` years`}</span>
                       </div>
                     </div>
                     {/* <div className="border-t border-gray-200 py-3.5 flex flex-col gap-3 mb-1"> 
                            <div className="flex justify-between items-center">
                               <span className="text-neutral-muted-12-400">Subtotal</span>
                               <span className="heading-14-inter-info">{`~ ${getCurrencyLabel(country_mstr)} ${formatMoney((((+selected_project?.projectcost!)||0)  / country_mstr?.currencyrate!),"tt")}`}</span>
                           </div>
                           <div className="flex justify-between items-center">
                               <span className="text-neutral-muted-12-400">Subsidy</span>
                               <span className="heading-14-inter-info">{"--"}</span>
                           </div>
                           <div className="flex justify-between items-center">
                               <span className="text-neutral-muted-12-400">GST
                                <span className="text-[10px] font-medium px-2 ml-2 py-0.5 rounded-[4px] border border-[rgba(252,211,77,1)] bg-orange-50 text-[rgba(217,119,6,1)]">  18%  </span>
                               </span>
                               <span className="heading-14-inter-info">{"--"}</span>
                           </div>
                        </div> */}
                       <div className="border-t border-dashed border-gray-200 py-3.5 flex flex-col gap-3 mb-1"> 
                           <div className="flex justify-between items-center">
                               <span className=" text-[12px] font-inters text-black flex ">Total system cost</span> 
                               <span className={costBreakdown.isBooked ? "heading-14-inter-info" : "heading-14-inter-info !text-[rgba(27,79,216,1)] "}>{`${getCurrencyLabel(country_mstr)} ${formatMoney((costBreakdown.total / country_mstr?.currencyrate!),"tt")}`}</span>
                           </div>
                           {costBreakdown.isBooked && <>
                           <div className="flex justify-between items-center">
                               <span className=" text-[12px] font-inters text-black flex ">Booking amount paid</span>
                               <span className="heading-14-inter-info">{`- ${getCurrencyLabel(country_mstr)} ${formatMoney((costBreakdown.booking / country_mstr?.currencyrate!),"tt")}`}</span>
                           </div>
                           <div className="flex justify-between items-center">
                               <span className=" text-[12px] font-inters text-black flex ">Remaining amount</span>
                               <span className="heading-14-inter-info !text-[rgba(27,79,216,1)] ">{`${getCurrencyLabel(country_mstr)} ${formatMoney((costBreakdown.remaining / country_mstr?.currencyrate!),"tt")}`}</span>
                           </div>
                           </>}
                        </div>
            
                       {/* <div className="flex justify-between items-center my-3">
                         <span className="text-[12px] font-inters text-black flex gap-2 pl-1">{<TimerIcon />}{`Installation completes in ${projectInstallationDays(selected_project)} days`}</span>
                       </div> */}
                         {/* <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{"~₹XX.X Lakh"}</span> */}

                    {/* CTA */}
                    {/* <button className="w-full py-2.5 border border-[#616161] rounded-md bg-white cursor-pointer flex items-center justify-center gap-1.5 text-sm font-medium text-black hover:bg-gray-50 transition-colors" onClick={()=>dispatch(setSeeProposal(true))} >
                        <ArticleIcon />
                        See full proposal
                    </button> */}
                </div>
            )}
        </div>
    );
};

/* ─── Next steps timeline ─── */

const withYou = [
    "Dedicated project support from design to activation",
    "Verified installer and quality-checked installation",
    "Clear milestone tracking in your dashboard",
];

/* ─── Main export ─── */

const PaymentSuccess = () => {
     const { roofAnalysis:{formDetails:{projectSetup},selected_project }}  = useAppSelector(state=>state.consumerReducers)
    const {user:{country_mstr}}  = useAppSelector(state=> state.auth)

    
const nextSteps = [
    {
        label: "Within 24–48 hours",
        detail: "Final system design and documents prepared",
        done: true,
    },
    {
        label: "Within 3–7 days",
        detail: "Installer visit scheduled and approvals initiated",
        done: false,
    },
    {
        label: `Installation phase (${projectInstallationDays(selected_project)} days)`,
        details: [
            "System installation, testing, and activation",
            "You receive updates at every milestone",
        ],
        done: false,
    },
];

    return (
    <div className="font-sans bg-white rounded-md overflow-hidden min-w-[800px]">

        {/* ── Top success banner ── */}
        <div className="flex flex-col items-center pt-3 pb-4 px-6 text-center">
            {/* Green checkmark badge */}
            <div className="mb-3">
                <VerifiedCircleIcon size={50} />
            </div>
            <h2 className="text-[20px] font-semibold text-[#252C32] mb-1.5">
                Payment successful — your solar journey has begun
            </h2>
            <p className="text-[13px] text-gray-500 max-w-full">
                Thank you for your trust. Our team is now preparing everything needed to start your installation.
            </p>
        </div>

        {/* ── Body: left + right ── */}
        <div className="grid grid-cols-[60%_40%] gap-2 p-5 pb-3 border border-gray-300 rounded-md">

            {/* Left — next steps + we're with you */}
            <div className="pl-10">
                <p className="text-[10px] font-Roboto uppercase text-gray-400 px-1 mb-4">
                    Next steps for your project
                </p>

                {/* Timeline */}
                <div className="flex flex-col gap-0">
                    {nextSteps?.map((step, i) => (
                        <div key={step.label} className="flex gap-3">
                            {/* Step indicator + connector line */}
                            <div className="flex flex-col items-center">
                                {step.done ? (
                                    <div className="w-6 h-6 rounded-full bg-gray-900 flex items-center justify-center flex-shrink-0 z-10">
                                        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                ) : (
                                    <div className="w-6 h-6 rounded-full border-2 border-gray-300 bg-white flex items-center justify-center flex-shrink-0 z-10">
                                        <span className="text-[10px] font-medium text-gray-400">{i + 1}</span>
                                    </div>
                                )}
                                {/* Connector */}
                                {i < nextSteps.length - 1 && (
                                    <div className="w-px flex-1 bg-gray-200 my-1" style={{ minHeight: "28px" }} />
                                )}
                            </div>

                            {/* Step content */}
                            <div className="pb-5">
                                <p className="text-[13px] font-semibold font-roboto text-[#000000] mb-1">{step.label}</p>
                                {step.detail && (
                                    <p className="text-[11px] text-gray-500 flex items-start gap-1.5">
                                        <span className="-mt-0.1 text-[#616161] font-Roboto flex-shrink-0">•</span> {step.detail}
                                    </p>
                                )}
                                {step.details && step.details.map((d) => (
                                    <p key={d} className="text-[11px] text-gray-500 flex items-start gap-1.5">
                                        <span className="-mt-0.1 text-[#616161] font-Roboto flex-shrink-0">•</span> {d}
                                    </p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* We're with you */}
                <div className="-mt-3">
                    <p className="text-[15px] font-inter text-[#2E2222] mb-3 mt-2">We're with you at every step</p>
                    <div className="flex flex-col gap-2.5 mb-4">
                        {withYou?.map((item) => (
                            <div key={item} className="flex items-center gap-2">
                                <IconCheckCircle />
                                <span className="text-[13px] text-[#000000] font-inter">{item}</span>
                            </div>
                        ))}
                    </div>
                    {/* <p className="text-[10px] text-[#000000] font-inter">
                        You'll also receive updates on WhatsApp, email, and inside your dashboard.
                    </p> */}
                </div>
            </div>

            {/* Right — reused Final Proposal Card */}
            <FinalProposalCard />
        </div>
    </div>
);}

export default PaymentSuccess;
